/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Badge, Collapse } from 'reactstrap';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import Session from './Session';

const ReservedSession = props => {

    // context
    const { theme, colors } = useContext(ThemeContext);

    // states
    const [isReservedSessionOpen, setIsReservedSessionOpen] = useState(true);
    const [sessionList, setSessionList] = useState([]);
    const [newReservedSession, setNewReservedSession] = useState([]);
    const [newRescheduledSession, setNewRescheduledSession] = useState([]);

    // utility functions
    const toggleReservedSession = () => setIsReservedSessionOpen(!isReservedSessionOpen);

    // useEffect
    useEffect(() => {
        try {
            if (props.sessions) {
                setSessionList(props.sessions);
            }
            if (props.newReservedSession) {
                setNewReservedSession(props.newReservedSession);
            }
            if (props.newRescheduledSession) {
                setNewRescheduledSession(props.newRescheduledSession);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User ReservedSession useEffect', 'Error in try catch block', err.stack);
        }
    }, [props.sessions])

    // function's return
    return (
        <div className="p-3 mt-3" style={theme.card} id="ReservedSessions">
            <div className="row px-3" onClick={toggleReservedSession} style={{ cursor: "pointer" }}>
                <span style={theme.headingBold}>Pending Payments <Badge style={{ backgroundColor: colors.primary }}>{sessionList.length}</Badge> </span>
                {
                    sessionList.length ?
                        isReservedSessionOpen
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i>{newReservedSession.length + newRescheduledSession.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>{newReservedSession.length + newRescheduledSession.length}</Badge> : null}</span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i>{newReservedSession.length + newRescheduledSession.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>{newReservedSession.length + newRescheduledSession.length}</Badge> : null}</span>
                        : null
                }

            </div>

            <Collapse isOpen={sessionList.length ? isReservedSessionOpen : false}>
                <hr />
                {
                    sessionList.map((item, index) => (
                        <Session key={index} handleModal={props.handleModal} detail={item} type="Reserved" index={index} history={props.history} newReservedSession={newReservedSession} />
                    ))
                }
            </Collapse>


        </div>
    )
}

export default ReservedSession;